import type React from 'react';

import { Link, type LinkProps } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';

import { useStyles } from 'components/events/styles';
import { getEventRoute } from 'config/router/utils';

interface EventLinkProps extends LinkProps {
  eventName: string;
  tournamentId: string;
  eventId: string;
  selectedDrawId?: string;
  className?: string;
  onClick?: () => void;
}

const EventLink: React.FC<React.PropsWithChildren<EventLinkProps>> = ({
  eventName,
  tournamentId,
  eventId,
  selectedDrawId,
  ...props
}) => {
  const { classes } = useStyles();

  return (
    <Link
      className={props.className ? props.className : classes.eventLink}
      component={RouterLink}
      to={!!tournamentId && getEventRoute(tournamentId, eventId, selectedDrawId)}
      underline="hover"
      {...props}
    >
      {eventName}
    </Link>
  );
};

export default EventLink;
